<template>
    <dl class="od-kv">
        <div v-for="item in items" :key="item.label" class="od-kv__row">
            <dt class="od-kv__label">{{ item.label }}</dt>
            <dd
                class="od-kv__value"
                :class="{
                    'od-kv__value--right': item.align === 'right',
                    'od-kv__value--strong': item.strong,
                    'od-mono': item.mono,
                }"
                :title="item.mono ? item.value : null"
            >
                <od-status-badge v-if="item.status" :status="item.status" />
                <template v-else>{{ item.value }}</template>
            </dd>
        </div>
    </dl>
</template>

<script>
import OdStatusBadge from './OdStatusBadge.vue';

/**
 * Vertical label/value list for narrow rails.
 * Item: { label, value, align?: 'right', strong?, mono?, status? }.
 */
export default {
    name: 'OdKeyValueList',
    components: { OdStatusBadge },
    props: {
        items: { type: Array, required: true },
    },
};
</script>
